import React from "react";
import Link from "next/link";

export default function Footer() {
  return (
    <div className="w-full bg-primary-blue">
      <div className="max-w-[1040px] mx-auto py-5 px-5 lg:px-5 xl:px-5">
        <div className="flex flex-col md:flex-row gap-4 justify-between  pt-5">
          <div className="py-5 basis-9/12 md:basis-8/12">
          <div className="flex flex-col md:flex-row gap-4 text-white py-5">
              <div className=""> 
                 <img src="/assets/logo-2.svg" />
              </div>
              <div> 

                <p className="text-white text-[1rem]  md:max-w-[277px]">We're here to ensure your deliveries arrive on time, every time.
                Trusted by thousands, loved by all.</p>
              </div>
            </div>
            
          <div className="flex flex-row gap-8 text-white">
            <Link href=""> Home</Link>
            <Link href="/#ourservices">Our Services</Link>
            <Link href="/about-us">About Us</Link>
            <Link href="/#contactus">Contact Us</Link>
            <Link href="/welcome">Login / Sign Up</Link>
          </div>
             
          {/* <div className=""> 
          <div> 
          <p className="text-bold text-white">+1306-880-3310</p>
          <p className="text-bold text-white">Aswiftcanada@gmail.com</p>
          </div>
          </div> */}

          </div>
          <div className="basis-3/12 md:basis-4/12">
             <h1 className="text-white sb-ac text-[24px]">Download Our App</h1>
              <div className="flex flex-row gap-4 py-3"> 
              <div> <img src="/assets/ios-w.svg" /></div>
                 <div> <img src="/assets/andriod-w.svg" /></div>
              </div>
          </div>
        </div>


       

        <div className="w-full h-[1px] bg-primary-grey mt-9 mb-7"></div>
        <div className="flex flex-col md:flex-row flex-wrap justify-center items-center md:justify-between">
          <div>
            <h1 className="text-[#D0D5DD]">
              © 2024 A-Swift. All rights reserved.
            </h1>
          </div>
          <div className="flex flex-row mt-5 md:mt-0 items-center gap-5">
            <Link href="">
              <img src="/assets/tw.svg" />
            </Link>
            <Link href="">
              <img src="/assets/link.svg" />
            </Link>
            <Link href="">
              <img src="/assets/inst.svg" />
            </Link>
            <Link href="">
              <img src="/assets/face.svg" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
